import KunLoading68 from './src/index'

KunLoading68.install = function (Vue) {
	Vue.component(KunLoading68.name, KunLoading68);
}

export default KunLoading68;
